export default "/_next/static/images/resolution-bot-icon-5340716ec430aee57e5b8853a4e86739.svg";